import type { PSLSDataServiceResponseType, PSLSDataType } from "../../types/PSLSDataType";

/**
 * Product specification lookup service Object formatter, used as part of the payload for finance rate and calculator
 * @param data: PSLSDataServiceResponseType
 */
export const formatPSLSObject = (data: PSLSDataServiceResponseType): PSLSDataType => {
    const spec = data.ProductSpecification;
    return {
        Suffix: {
            Code: spec.Suffix.Code,
            Katashiki: spec.Suffix.Katashiki,
            Options: spec.Suffix.Options.map((option) => ({ Code: option.SMS.Code, Value: option.SMS.Value })),
            AvailableFromDate: spec.Suffix.AvailableFromDate,
            AvailableToDate: spec.Suffix.AvailableToDate,
        },
        LocalConfiguration: spec.LocalConfiguration,
        PostProductionOptions: spec.PostProductionOptions.map((ppo) => ppo.Code),
        Accessories: spec.Accessories.map((acc) => acc.PartNumber),
        Packs: spec.Packs.map((pck) => ({
            Code: pck.Code,
            PostProductionOptions: pck.PostProductionOptions.map((ppo) => ppo.Code),
            Accessories: pck.Accessories.map((acc) => acc.PartNumber),
        })),
        ColourCode: spec.ColourInformation.ExteriorColourCode,
        UpholsteryCode: `${spec.ColourInformation.TrimCode}${spec.ColourInformation.InteriorColourCode}`,
    };
};
